import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../Pages/Home/Home";
import ScrollToTop from "../Components/ScrollToTop";
import Individual from "../Pages/Services/Individual";
import Provider from "../Pages/Services/Provider";
import ThankyouPage from "../Pages/ThankyouPage";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import TermsAndCondition from "../Pages/TermsAndCondition";



function AllRoutes() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/service/individual" element={<Individual />} />
        <Route path="/service/provider" element={<Provider />} />
        <Route path="/success" element={<ThankyouPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/terms-and-condition" element={<TermsAndCondition/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default AllRoutes;
